import { v4 as uuidv4 } from "uuid";
import {
  Condition,
  Entities,
  FormData,
  ID,
  Page,
  Part,
  Section,
} from "./types";

type Fields = "pages" | "sections" | "parts" | "conditions";

const entities: Entities = {
  pages: {
    byId: {},
    allIds: [],
  },
  sections: {
    byId: {},
    allIds: [],
  },
  parts: {
    byId: {},
    allIds: [],
  },
  conditions: {
    byId: {},
    allIds: [],
  },
};

const genEntity = <T extends Page | Section | Part | Condition>(
  field: Fields,
  data: T,
  entities: Entities
) => {
  const id = uuidv4() as ID;
  entities[field].byId[id] = {
    ...data,
    id,
  };
  entities[field].allIds = [...entities[field].allIds, id];
  return id;
};

const genPage = (data: Page, entities: Entities) => {
  return genEntity<Page>("pages", data, entities);
};

const genSection = (data: Section, entities: Entities) => {
  const sectionId = genEntity<Section>("sections", data, entities);
  entities.pages.byId[data.pageId]?.sections.push(sectionId);
  return sectionId;
};

const genPart = (data: Part, entities: Entities) => {
  const partId = genEntity<Part>("parts", data, entities);
  entities.sections.byId[data.sectionId]?.parts.push(partId);
  return partId;
};
const genCondition = (data: Condition, entities: Entities) => {
  const conditionId = genEntity<Condition>("conditions", data, entities);
  entities.parts.byId[data.partId]?.conditions.push(conditionId);
  return conditionId;
};

const pageOne = genPage(
  {
    id: "",
    label: "Motors",
    short: "motors",
    description: "",
    layout: "rows",
    sections: [],
  },
  entities
);

const pageOneSectionOne = genSection(
  {
    id: "",
    label: "Motor Options",
    type: "multiple",
    pageId: pageOne,
    parts: [],
  },
  entities
);

const motorOption = genPart(
  {
    id: "",
    label: "Cool Motor",
    price: null,
    discount: null,
    image: "",
    color: "",
    default: "deselected",
    maxQuantity: "1",
    sectionId: pageOneSectionOne,
    pageId: pageOne,
    conditions: [],
  },
  entities
);

const motorOption2 = genPart(
  {
    id: "",
    label: "Cool Motor",
    price: 100,
    discount: "",
    image: "",
    color: "",
    default: "deselected",
    maxQuantity: "1",
    sectionId: pageOneSectionOne,
    pageId: pageOne,
    conditions: [],
  },
  entities
);

const motorOption3 = genPart(
  {
    id: "",
    label: "Cool Motor",
    price: 100,
    discount: "",
    image: "",
    color: "",
    default: "deselected",
    maxQuantity: "1",
    sectionId: pageOneSectionOne,
    pageId: pageOne,
    conditions: [],
  },
  entities
);

const motorCondition = genCondition(
  {
    id: "",
    if: "selected",
    field: motorOption2,
    should: "packaged",
    partId: motorOption,
    sectionId: pageOneSectionOne,
    pageId: pageOne,
  },
  entities
);

const pageTwo = genPage(
  {
    id: "",
    label: "Colors",
    short: "colors",
    description: "",
    layout: "rows",
    sections: [],
  },
  entities
);
export const devData: FormData = {
  entities,
  post: {
    disclaimers: {
      summary_photo_disclaimer: "Photo is no accurate.",
      footer_disclaimer: "Footer disclaimer",
    },
  },
  image:
    "https://avid-boats.com/wp-content/uploads/2021/09/23-Fusion-wT-top.png",
  app_version: uuidv4(), //prevents persistence since our ids will be unique each load.
};

export default devData;
